<template>
  <v-flex xs12 sm6 d-flex>
    <v-text-field
      v-model="terminalNumber"
      label="Número do Terminal"
    ></v-text-field>
  </v-flex>
</template>
<script>
import { mapGetters } from "vuex";
import * as business from "@/helpers/business";

export default {
  name: "TerminalNumber",
  computed: {
    terminalNumber: {
      get() {
        return this.model;
      },
      set(newTerminalNumber) {
        this.$store.dispatch("payments/setTerminalNumber", newTerminalNumber);
        this.model;
      },
    },
    ...mapGetters({
      model: "payments/filtersTerminalNumber",
    }),
  },
  data: () => ({}),
};
</script>








